const ITEMS = [
  "Meubels afvoeren",
  "Volledige woningontruiming",
  "Tuinafval",
  "Recyclage",
  "Geen rommel. Geen gedoe.",
  "Gratis offerte met foto",
  "Actief in heel België",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative z-10 -rotate-1 overflow-hidden border-y-4 border-ink bg-safety py-3" data-testid="services-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-display text-2xl font-extrabold uppercase tracking-wide text-ink">
                  {item}
                </span>
                <span className="h-2.5 w-2.5 rotate-45 bg-ink" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
